var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"subtitle-2",attrs:{"cols":"2"}},[_c('f-text',{attrs:{"value":_vm.displayName},on:{"input":(v) => _vm.setCustomName(v)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }